import React, {useState} from 'react';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import {Col, Input, Typography} from 'antd';
import {fieldColProps} from '../gridHelpers';

const TextBox = (props) => {
  const {formikProp} = props;
  const textField = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[textField.name] && props.customEvents[textField.name]
    : {};
  const [isFormInvalid, setIsFormInvalid] = useState(false);

  const InputComponent: any = textField.multiline ? Input.TextArea : Input;

  return (
    <Col {...fieldColProps(textField)}>
      <FieldLabel field={textField} />
      <InputComponent
        type={textField.multiline ? undefined : textField.htmlInputType}
        disabled={textField.isDisabled ?? false}
        readOnly={textField?.readonly}
        rows={textField.rows}
        name={textField.name}
        status={textField.required && isFormInvalid ? 'error' : undefined}
        value={formikProp.values[textField.name] ?? ''}
        onChange={(e: any) => {
          setIsFormInvalid(e.target.value.length <= 0);
          formikProp.setFieldValue(textField.name, e.target.value);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](e, formikProp.setFieldValue);
        }}
        // Mark touched on blur (the old <Field as={TextField}> did) so errors
        // show when leaving an invalid field, not only after submit.
        onBlur={() => formikProp.setFieldTouched(textField.name, true)}
        onClick={(e: any) => {
          setIsFormInvalid(e.target.value?.length <= 0);
          customEvents &&
            customEvents.onClick &&
            customEvents['onClick'](e, formikProp.setFieldValue, formikProp.values);
        }}
      />
      {textField.note && <Typography.Text type="secondary">{textField.note}</Typography.Text>}
      <FieldError name={textField.name} />
    </Col>
  );
};

export default TextBox;
